export default "__VITE_ASSET__X6DW81nC__"